import createDecorator from "final-form-calculate";
import { Decorator } from "final-form";
import { FormValues } from "./types";

export const decorators = createDecorator({
  field: 'ISRC',
  updates: (_, __, allValues) => {
    const values = { ...allValues } as FormValues;

    if (!values.ISRC) {
      values.isrc = '';
    }

    return values;
  }
}, ) as Decorator<FormValues>;
